export class ErrorsMessages {

    public static errorRouteParameter = 'خطای وارد نشدن پارامتر در مسیر url';

    public static errorTitle = '';
    public static badRequest = 'اطلاعات وارد شده صحیح نمی باشد';
    /** start authentication messages */
    /** ---- login */

    public static disableUser = 'کاربر مورد نظر غیر فعال می باشد';
    public static existUser = 'این کاربر در سیستم موجود می باشد';

    /** ---- activation code */
    public static unauthorizedToken = 'توکن وارد شده نامعتبر است';
    public static expiredToken = 'توکن وارد شده منقضی شده است';

    /** ---- forget password */
    public static excessiveRequest = 'تعداد درخواست شما بیش از حد مجاز می باشد';
    /** end authentication messages */

    public static error500 = 'سرویس در دسترس نمی باشد';
    public static error401 = 'شما دسترسی لازم را ندارید';
    public static error403 = 'خطای دسترسی به مسیر درخواستی';
    public static error502 = 'خطای سیستمی Gateway';
    public static error504 = 'خطای سیستمی Gateway';
    public static error404 = 'خطای سیستمی پیدا نکردن url';
    public static invalidUsernameAndPassword = 'نام کاربری و کلمه عبور اشتباه است';


}
